/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AssetStatus = 'approved' | 'rejected' | 'pending' | 'created' | 'expired' | 'uploaded' | 'awaiting_approval' | 'import' | 'failed' | 'archived' | 'draft';

export const AssetStatus = {
    Approved: 'approved' as AssetStatus,
    Rejected: 'rejected' as AssetStatus,
    Pending: 'pending' as AssetStatus,
    Created: 'created' as AssetStatus,
    Expired: 'expired' as AssetStatus,
    Uploaded: 'uploaded' as AssetStatus,
    AwaitingApproval: 'awaiting_approval' as AssetStatus,
    Import: 'import' as AssetStatus,
    Failed: 'failed' as AssetStatus,
    Archived: 'archived' as AssetStatus,
    Draft: 'draft' as AssetStatus
};

